import React from 'react';
import { UsersIcon, BookOpenIcon, GiftIcon, StarIcon } from 'lucide-react';
export function StatsStrip() {
  const stats = [{
    icon: UsersIcon,
    value: '+2.000',
    label: 'contribuyentes confían'
  }, {
    icon: BookOpenIcon,
    value: '3',
    label: 'Tomos listos'
  }, {
    icon: GiftIcon,
    value: '1',
    label: 'Bonus incluido'
  }, {
    icon: StarIcon,
    value: '4.9/5',
    label: '⭐⭐⭐⭐⭐'
  }];
  return <section className="py-12 px-4 sm:px-6 lg:px-8 bg-white border-y border-[#EAE5DC]" data-id="element-174">
      <div className="max-w-5xl mx-auto" data-id="element-175">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-176">
          {stats.map((stat, index) => <div key={index} className="text-center" data-id="element-177">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[#5BB4A0]/10 mb-3" data-id="element-178">
                <stat.icon className="w-6 h-6 text-[#5BB4A0]" data-id="element-179" />
              </div>
              <div className="text-2xl sm:text-3xl font-bold text-[#5BB4A0] mb-1" data-id="element-180">
                {stat.value}
              </div>
              <div className="text-sm text-[#6B7280]" data-id="element-181">{stat.label}</div>
            </div>)}
        </div>
      </div>
    </section>;
}